import { IWorkSpaceRepository } from "@/core/repositories/workspace";

export class GetWorkSpaceRefreshTokenUseCase {
  constructor(private readonly workspaceRepository: IWorkSpaceRepository) {}

  async execute(): Promise<string | null> {
    const workSpaceRefreshToken = await this.workspaceRepository.getWorkspaceRefreshToken();
    return workSpaceRefreshToken?.refreshToken ?? null;
  }
}
